
import "bootstrap";
import "simplebar";
import * as Waves from "node-waves";
import * as feather from "feather-icons";
import "swiper";
import htmx from "htmx.org";
// import "../theme/js/plugins/lord-icon-2.1.0";
import { defineElement } from "@lordicon/element";
import swal from "sweetalert2";



window.feather = feather.default;
window.Waves = Waves;

defineElement();

// form confirmations
document.addEventListener("submit", function (event) {
    // parameters: data-confirm: message to show in confirmation dialog
    // data-confirm:title: title to show in confirmation dialog
    // data-confirm:confirm-button: text for confirm button
    // data-confirm:cancel-button: text for cancel button

    const form = event.target;

    if (form.hasAttribute("data-confirm")) {
        event.preventDefault();

        const message = form.getAttribute("data-confirm");
        const title = form.getAttribute("data-confirm:title") || "Are you sure?";
        const confirmButtonText = form.getAttribute("data-confirm:confirm-button") || "Yes";
        const cancelButtonText = form.getAttribute("data-confirm:cancel-button") || "No";

        swal.fire({
            title: title,
            text: message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
        }).then((result) => {
            if (result.isConfirmed) {
                form.submit();
            }
        });
    }
});
